import { Button, Table } from "antd";
import React, { useEffect, useState } from "react";
import Style from './SupportListTabel.module.css'
import moment from "moment-jalaali";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { errorToast } from "../../Utils/Toast/Toast";
import { getSupportListApi } from "../../Api/DeliveryBarest";
const SupportListTabel = () => {
    const[dataTabelState,setDataTabelState]=useState()
    const history=useHistory()
    useEffect(() => {
        getUserInfoSuport();
      }, []);
    
      const getUserInfoSuport = async () => {
        getSupportListApi((succ,res)=>{
          if(succ){
            if(res.status===0){
              errorToast("مشکلی پیش آمده است")
            }else{
                setDataTabelState(res.support);
            }
          }else{
            console.error("خطایی در سرور رخ داده است")
          }
        })
      };

      const handleRedirect = (record) => {
        if (record.status === "2" && record.score === "") {
          return <Button onClick={()=>history.push(`/supportscore/${record.id}`)}>ثبت امتیاز</Button>
        } else if (record.status === "2" && record.score !== "") {
         return record.score
        } else {
          return ""
        }
      };
  const columns = [
    {
      title: "عنوان",
      dataIndex: "title",
      key: "title",
      render: (text,record) => <span style={{color:"#007efc",textDecoration:'underLine'}} onClick={() =>  history.push(`/supportchat/${record.id}`)}>{text}</span>,
    },
    {
      title: "وضعیت",
      dataIndex: "status",
      key: "status",
      render: (text, record) => (
        <p>
          {record.status==="0"?"جدید":record.status==="1"?"درحال بررسی":"خاتمه یافته"}
        </p>
      ),
    },
    {
      title: "تاریخ",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "امتیاز",
      dataIndex: "score",
      key: "score",
      render: (text,record) => <div>{handleRedirect(record)}</div>,
    },
  ];
  const dataTabel=[]
  dataTabelState?.forEach(element => {
    dataTabel.push({
        ...element,
        date:<span style={{direction:'ltr'}}>{moment.unix(parseInt(element.date)).format("jYYYY/jM/jD--hh:mm")}</span>,
        key:element.id,
    })
  });

  return (
    <div className={Style.TabelHolder}>
      <Table
        columns={columns}
        dataSource={dataTabel}
        loading={dataTabelState===undefined}
        pagination={{
          position: ["bottomCenter"],
          style: { direction: "ltr" },
          pageSize:10
        }}
        locale={{ emptyText: (
          <div style={{ textAlign: "center",direction:"rtl" }}>
            درخواستی یافت نشد!
          </div>
        ) }}
      />
    </div>
  );
};

export default SupportListTabel;
